export default __webpack_public_path__ + "static/media/lambra-logo.a500a0c9.png";